var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b, _c;
import { Accordion, AccordionSet, Badge, Button, List, Loading, Modal, ModalFooter, Select, } from '@folio/stripes/components';
import React, { useEffect, useState } from 'react';
import { Field, Form } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { dateFromYYYYMMDD } from '../utils/DateUtils';
import css from './PurgeModal.css';
export var AgeCriteria;
(function (AgeCriteria) {
    AgeCriteria["MONTHS_3"] = "MONTHS_3";
    AgeCriteria["MONTHS_6"] = "MONTHS_6";
    AgeCriteria["YEAR_1"] = "YEAR_1";
    AgeCriteria["YEARS_2"] = "YEARS_2";
})(AgeCriteria || (AgeCriteria = {}));
var AgeCriteriaLabels = (_a = {},
    _a[AgeCriteria.MONTHS_3] = 'ui-calendar.purgeModal.criteria.age.months3',
    _a[AgeCriteria.MONTHS_6] = 'ui-calendar.purgeModal.criteria.age.months6',
    _a[AgeCriteria.YEAR_1] = 'ui-calendar.purgeModal.criteria.age.year1',
    _a[AgeCriteria.YEARS_2] = 'ui-calendar.purgeModal.criteria.age.years2',
    _a);
var AgeCriteriaMonths = (_b = {},
    _b[AgeCriteria.MONTHS_3] = 3,
    _b[AgeCriteria.MONTHS_6] = 6,
    _b[AgeCriteria.YEAR_1] = 12,
    _b[AgeCriteria.YEARS_2] = 24,
    _b);
export var AssignmentCriteria;
(function (AssignmentCriteria) {
    AssignmentCriteria["NONE"] = "NONE";
    AssignmentCriteria["ANY"] = "ANY";
})(AssignmentCriteria || (AssignmentCriteria = {}));
var AssignmentCriteriaLabels = (_c = {},
    _c[AssignmentCriteria.NONE] = 'ui-calendar.purgeModal.criteria.assignment.none',
    _c[AssignmentCriteria.ANY] = 'ui-calendar.purgeModal.criteria.assignment.any',
    _c);
export var FORM_ID = 'ui-calendar-purge-old-calendar-form';
export var getCalendarsToPurge = function (calendars, ageCriteria, assignmentCriteria) {
    if (ageCriteria === void 0) { ageCriteria = undefined; }
    if (assignmentCriteria === void 0) { assignmentCriteria = undefined; }
    if (ageCriteria === undefined || assignmentCriteria === undefined) {
        return [];
    }
    var endBefore = new Date().setMonth(new Date().getMonth() - AgeCriteriaMonths[ageCriteria]);
    return calendars
        .filter(function (calendar) {
        return assignmentCriteria === AssignmentCriteria.ANY || calendar.assignments.length === 0;
    })
        .filter(function (calendar) { return dateFromYYYYMMDD(calendar.endDate).getTime() < endBefore; });
};
export var PurgeModal = function (props) {
    var intl = useIntl();
    var _a = useState(false), isSubmitting = _a[0], setIsSubmitting = _a[1];
    // reset submitting on mount/unmount
    useEffect(function () { return setIsSubmitting(false); }, []);
    return (React.createElement(Modal, { dismissible: true, open: props.open, onClose: props.onClose, label: React.createElement(FormattedMessage, { id: "ui-calendar.purgeModal.label" }), "aria-label": intl.formatMessage({ id: 'ui-calendar.purgeModal.label' }), size: "small", footer: React.createElement(ModalFooter, null,
            React.createElement(Button, { disabled: isSubmitting, buttonStyle: "danger", form: FORM_ID, type: "submit" }, isSubmitting ? React.createElement(Loading, null) : React.createElement(FormattedMessage, { id: "stripes-core.button.delete" })),
            React.createElement(Button, { onClick: props.onClose },
                React.createElement(FormattedMessage, { id: "stripes-core.button.cancel" }))) },
        React.createElement(Form, { initialValues: {
                ageCriteria: undefined,
                assignmentCriteria: undefined,
            }, onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
                var toPurge, e_1, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            setIsSubmitting(true);
                            toPurge = getCalendarsToPurge(props.dataRepository.getCalendars(), values.ageCriteria, values.assignmentCriteria);
                            if (toPurge.length === 0) {
                                props.onClose();
                                setIsSubmitting(false);
                                return [2 /*return*/];
                            }
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, 5, 6]);
                            return [4 /*yield*/, props.dataRepository.deleteCalendars(toPurge)];
                        case 2:
                            _b.sent();
                            props.onClose();
                            return [3 /*break*/, 6];
                        case 3:
                            e_1 = _b.sent();
                            // eslint-disable-next-line no-console
                            console.error(e_1);
                            // eslint-disable-next-line no-alert
                            _a = alert;
                            return [4 /*yield*/, e_1.response.text()];
                        case 4:
                            // eslint-disable-next-line no-alert
                            _a.apply(void 0, [_b.sent()]);
                            return [3 /*break*/, 6];
                        case 5:
                            setIsSubmitting(false);
                            return [7 /*endfinally*/];
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, render: function (params) {
                var handleSubmit = params.handleSubmit, values = params.values;
                var toPurge = getCalendarsToPurge(props.dataRepository.getCalendars(), values.ageCriteria, values.assignmentCriteria);
                return (React.createElement("form", { id: FORM_ID, onSubmit: handleSubmit },
                    React.createElement(Field, { name: "ageCriteria", render: function (fieldProps) { return (React.createElement(Select, __assign({}, fieldProps, { required: true, label: React.createElement(FormattedMessage, { id: "ui-calendar.purgeModal.criteria.age.prompt" }), fullWidth: true, dataOptions: __spreadArray([
                                { value: undefined, label: '' }
                            ], Object.entries(AgeCriteriaLabels).map(function (_a) {
                                var value = _a[0], label = _a[1];
                                return ({
                                    value: value,
                                    label: intl.formatMessage({ id: label }),
                                });
                            }), true) }))); } }),
                    React.createElement(Field, { name: "assignmentCriteria", render: function (fieldProps) { return (React.createElement(Select, __assign({}, fieldProps, { required: true, label: React.createElement(FormattedMessage, { id: "ui-calendar.purgeModal.criteria.assignment.prompt" }), fullWidth: true, dataOptions: __spreadArray([
                                { value: undefined, label: '' }
                            ], Object.entries(AssignmentCriteriaLabels).map(function (_a) {
                                var value = _a[0], label = _a[1];
                                return ({
                                    value: value,
                                    label: intl.formatMessage({ id: label }),
                                });
                            }), true) }))); } }),
                    React.createElement(AccordionSet, null,
                        React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-calendar.purgeModal.deletionList.label" }), closedByDefault: true, displayWhenClosed: React.createElement(Badge, { color: "default" }, toPurge.length), displayWhenOpen: React.createElement(Badge, { color: "default" }, toPurge.length) },
                            React.createElement(List, { items: toPurge.map(function (c) { return c.name; }), listStyle: "bullets", isEmptyMessage: React.createElement("div", { className: css.noneToDelete },
                                    React.createElement(FormattedMessage, { id: "ui-calendar.purgeModal.deletionList.empty" })) })))));
            } })));
};
export default PurgeModal;
